export default __webpack_public_path__ + "static/media/contact-icon.e02be4fc.svg";